import { render, staticRenderFns } from "./productHardware.vue?vue&type=template&id=65977358&scoped=true"
import script from "./productHardware.vue?vue&type=script&lang=js"
export * from "./productHardware.vue?vue&type=script&lang=js"
import style0 from "./productHardware.vue?vue&type=style&index=0&id=65977358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65977358",
  null
  
)

export default component.exports